const NS = 'SiteFooterSitemapWidget';
const CLS = 'siteFooterSitemapWidget';

import { scrollIntoView } from 'scroll-js';

export class SiteFooterSitemapWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.slideAnimationDuration = 750;
		this.scrollAnimationDuration = 750;
		this.scrollEasing = 'ease-in-out';
		this.isAnimating = false;
		this.$siteFooter = this.$element.parents('.siteFooterWidget');

		this.$element.on('siteFooterSitemapWidget.toggle', () => {
			if(!this.isAnimating) {
				if(this.$element.attr('data-closed') === 'true') {
					this.$element.attr('data-closed', false);
					this.$siteFooter.trigger('siteFooterWidget.siteFooterLinksWidget.sitemapButton.toggleClass', {});
					this.isAnimating = true;
					this.$element.slideDown({
						duration: this.slideAnimationDuration,
						complete: () => {
							scrollIntoView(this.$element[0], document.body, { duration: this.scrollAnimationDuration, easing: this.scrollEasing }).then(() => {
								this.isAnimating = false;
							});
						}
					});
				}
				else {
					this.isAnimating = true;

					this.$element.slideUp({
						duration: this.slideAnimationDuration,
						complete: () => {
							this.$element.attr('data-closed', true);
							this.$siteFooter.trigger('siteFooterWidget.siteFooterLinksWidget.sitemapButton.toggleClass', {});
							this.isAnimating = false;
						}
					});
				}
			}
		});
	}
}
